import api from 'api'

export type ResolveFieldglassIssueRequest = {
  issueId: number
}

export const resolveFieldglassIssue = async (
  request: ResolveFieldglassIssueRequest
): Promise<void> => {
  await api.post(`/admin/fieldglass/issues/${request.issueId}/resolve`)
}
